module.exports = __webpack_public_path__ + "static/media/mask_v2_bb.ae3ff3dc.png";